import { defaultTheme } from 'evergreen-ui';

const theme = {
    ...defaultTheme
};

const PROViDER_APP_TEXT_COLOR = '#252838';

// evergreen-ui's theme has a hidden color attribute
// this sets that hidden attribute
[
    theme.typography.headings,
    theme.typography.paragraph,
    theme.typography.text
].forEach((typo) => {
    for (const k of Object.keys(typo)) {
        // @ts-ignore
        typo[k] = {
            // @ts-ignore
            ...typo[k],
            color: PROViDER_APP_TEXT_COLOR
        };
    }
});

export const providerAppTheme = theme;
